export interface MetricsRow {
  eventName?: string | null;
  priorScore?: number | null;
  currentAvg?: number | null;
}

interface MetricsTableProps {
  headers: string[];
  rows: MetricsRow[];
  compact?: boolean;
  headerSpacing?: string;
  rowSpacing?: string;
}

export const formatEventName = (eventName?: string | null): string => {
  if (!eventName) return '';
  return eventName
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatScore = (score?: number | null) => {
  if (score === null || score === undefined) {
    return '-';
  }
  return score.toFixed(1);
};

export const MetricsTable = ({
  headers,
  rows,
  compact = false,
  headerSpacing,
  rowSpacing
}: MetricsTableProps) => {
  const defaultHeaderSpacing = compact ? 'pb-2' : 'pb-4';
  const defaultRowSpacing = compact ? 'py-1' : 'pb-3 pt-3';

  const headerPadding = headerSpacing ?? defaultHeaderSpacing;
  const rowPadding = rowSpacing ?? defaultRowSpacing;
  return (
    <table className="w-full rounded-lg overflow-hidden">
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th
              key={header}
              className={`${
                index === 0 ? 'text-left' : 'text-center'
              } text-muted-foreground w-2/5 border-b border-border ${headerPadding} text-xs font-semibold`}
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.eventName}>
            <td
              className={`w-2/5 ${rowPadding} text-muted-foreground font-sans text-xs font-semibold`}
            >
              {formatEventName(row.eventName)}
            </td>
            <td
              className={`text-center ${rowPadding} w-3/10 text-destructive-foreground font-sans text-xs font-semibold`}
            >
              {formatScore(row.priorScore)}
            </td>
            <td
              className={`text-center ${rowPadding} w-3/10 text-success-foreground font-sans text-xs font-semibold`}
            >
              {formatScore(row.currentAvg)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
